import { TemplateDrawerFooter } from 'app/domains/esigning/components/TemplateDrawer';
import { SubmitAlert } from './SubmitAlert';
import { SubmitButton } from './SubmitButton';
export function Footer(props) {
    const { showSubmitAlert } = props;
    return (<TemplateDrawerFooter>
      {showSubmitAlert && <SubmitAlert />}
      <SubmitButton />
    </TemplateDrawerFooter>);
}
